<template>
    <div class="kv-popup-container" ref="container">
        <!-- Gatilho -->
        <div>
            <slot name="trigger" :toggle="toggleShow" :isOpen="isOpen"></slot>
        </div>

        <!-- Conteúdo do popup -->
        <transition name="fade" @after-leave="$emit('after-close')" @enter="onEnter" @after-enter="$emit('after-open')" @before-enter="$emit('before-open')">
            <div v-if="isOpen" class="kv-popup-content" ref="popup" :style="{
                ...positionStyle,
                maxWidth: maxWidth,
                minWidth: minWidth
            }" @click.stop>
                <slot name="content" :toggle="toggleShow" :isOpen="isOpen"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "KvPopup",
    emits: ["after-close", "after-open", "before-open", "before-close", "close-outside"],
    props: {
        placement: {
            type: String,
            default: "bottom right",
        },
        maxWidth: {
            type: String,
            default: null
        },
        minWidth: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isOpen: false,
            actualPlacement: "",
            positionStyle: {
                top: "0px",
                left: "0px",
            }
        };
    },
    mounted() {
        document.addEventListener("click", this.handleOutside, true);
        window.addEventListener("resize", this.adjustPlacement);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleOutside, true);
        window.removeEventListener("resize", this.adjustPlacement);
    },
    methods: {
        onEnter(el) {
            this.adjustPlacement();
        },
        toggleShow(forceState) {
            const nextState = typeof forceState === "boolean" ? forceState : !this.isOpen;

            if (this.isOpen && !nextState) {
                this.$emit("before-close");
            }

            this.isOpen = nextState;
        },
        handleOutside(e) {
            const container = this.$refs.container;
            if (this.isOpen && container && !container.contains(e.target)) {
                this.toggleShow(false);
                this.$emit("close-outside");
            }
        },
        adjustPlacement() {
            const trigger = this.$refs.container;
            const popup = this.$refs.popup;

            if (!trigger || !popup) return;

            const triggerRect = trigger.getBoundingClientRect();
            const popupRect = popup.getBoundingClientRect();

            const parts = this.placement.trim().split(/\s+/);
            const vertical = parts.find(p => ["top", "bottom"].includes(p)) || "bottom";
            const horizontal = parts.find(p => ["left", "right", "center"].includes(p)) || "right";

            let top = 0;
            let left = 0;

            // === Vertical ===
            if (vertical === "bottom") {
                top = triggerRect.bottom + 4;
            } else {
                top = triggerRect.top - popupRect.height - 4;
            }

            // === Horizontal ===
            if (horizontal === "right") {
                left = triggerRect.left;
            } else if (horizontal === "left") {
                left = triggerRect.right - popupRect.width;
            } else {
                // center
                left = triggerRect.left + (triggerRect.width / 2) - (popupRect.width / 2);
            }

            // Impede de sair da tela
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            top = Math.max(4, Math.min(top, viewportHeight - popupRect.height - 4));
            left = Math.max(4, Math.min(left, viewportWidth - popupRect.width - 4));

            this.positionStyle = {
                top: `${top}px`,
                left: `${left}px`,
            };
        }
    },
};
</script>

<style lang="less">
.kv-popup-container {
    position: relative;
    display: inline-block;
}

.kv-popup-content {
    position: fixed;
    background: #fff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 12px;
    z-index: 100;
    display: block;
    width: max-content;
    height: max-content;
    max-width: calc(100dvw - 10px);
}

.kv-popup-title {
    margin-bottom: 12px;
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #4D5761;
}

.kv-popup-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* === Animação === */
.fade-leave-active {
    transition: all 0.15s ease;
}

.fade-leave-to {
    opacity: 0;
    transform: translateY(-3px);
}
</style>
